import { render, staticRenderFns } from "./snippet.vue?vue&type=template&id=e78848b0&lang=pug&"
import script from "./snippet.vue?vue&type=script&lang=js&"
export * from "./snippet.vue?vue&type=script&lang=js&"
import style0 from "./snippet.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports